// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__yniO4","cardSize_XS":"card_cardSize_XS__4jbhY","cardSize_S":"card_cardSize_S__4Kq8G","cardSize_M":"card_cardSize_M__Cx9mF"};